import { MessageFilled } from "@ant-design/icons";
import { Flex } from "antd";
import { FC, useCallback } from "react";
import { TaskEntityBase, TaskStatus } from "tm-shared/types";

import { StatusCycleButton } from "@/domains/tasks";
import { StatusIndicator } from "@/domains/tasks";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledCommentIndicator, StyledTaskProductsMatrix } from "./Styled";

interface ProductsMatrixTaskProps {
    name: string;
    barcode: string;
    isActive: boolean;
    onChangeActive: (id: string) => void;
    onChangeStatus: (status: TaskStatus, barcode: string) => void;
    payload: TaskEntityBase | null;
}

export const ProductsMatrixTask: FC<ProductsMatrixTaskProps> = ({
    name,
    barcode,
    isActive,
    onChangeActive,
    onChangeStatus,
    payload,
}) => {
    const hasComment = !!payload?.comment;
    const status = payload?.status ?? TaskStatus.Incomplete;

    const handleSelectTask = useCallback(() => {
        onChangeActive(barcode);
    }, [barcode, onChangeActive]);

    const handleChangeStatus = useCallback(
        (status: TaskStatus) => {
            onChangeStatus(status, barcode);
        },
        [barcode, onChangeStatus],
    );

    return (
        <StyledTaskProductsMatrix
            $isActive={isActive}
            onClick={handleSelectTask}
        >
            <PrimaryText>
                {name} ({barcode})
            </PrimaryText>

            <Flex justify="center" align="center">
                <StyledCommentIndicator>
                    {hasComment && (
                        <StatusIndicator type="warning">
                            <MessageFilled />
                        </StatusIndicator>
                    )}
                </StyledCommentIndicator>

                <StatusCycleButton
                    value={status}
                    onChange={handleChangeStatus}
                    dimension={48}
                    border={false}
                />
            </Flex>
        </StyledTaskProductsMatrix>
    );
};
